import { get } from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import MoreInfoPage from './MoreInfoPage';
import DocumentsReqPage from './DocumentsReqPage';
import ConfirmationPage from './ConfirmationPage';
import FinalSubmitErrorPage from './FinalSubmitErrorPage';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import { getAppPendVerificationDetails } from './AppPendPageAction';
import { isAppPendSupported } from '../../../shared-utilities/checkNativeSupport';
import * as SLIDES from './constants/slides';
import { FLOW_TYPE } from '../../../framework/App/AppConstants';
import { WORKFLOW_STATUS } from './constants/status';
import OlderVersionAppPage from './OlderVersionAppPage';
import { trackTransition } from '../../../framework/store/FPTI/FPTIActions';

const AppPendSlides = {
    MoreInfoPage,
    DocumentsReqPage,
    ConfirmationPage,
    FinalSubmitErrorPage
};

export class AppPendPage extends Component {
    static propTypes = {
        onComponentDidMount: PropTypes.func.isRequired,
        workflowId: PropTypes.string.isRequired,
        dueDate: PropTypes.string.isRequired,
        workflowStatus: PropTypes.string.isRequired,
        requiredDocuments: PropTypes.array.isRequired,
        flow: PropTypes.string.isRequired,
        isTransactionalFlow: PropTypes.bool.isRequired,
        appUnderReview: PropTypes.bool.isRequired,
        finalSubmitRetryCount: PropTypes.number.isRequired
    };

    static defaultProps = {
        onComponentDidMount: () => {}
    };

    state = {
        currentSlide: SLIDES.DOCUMENTS_REQUIRED,
        appPendSupported: true,
    };

    async componentDidMount() {
        const { workflowId, onComponentDidMount, flow } = this.props;

        if (flow === FLOW_TYPE.VENICE && !isAppPendSupported()) {
            this.setState({ appPendSupported: false });
        } else {
            await onComponentDidMount(workflowId);
            const { isTransactionalFlow, appUnderReview } = this.props;

            if (appUnderReview) {
                this.navigate(SLIDES.CONFIRMATION);
            } else if (isTransactionalFlow) {
                this.navigate(SLIDES.MORE_INFO);
            }
        }
    }

    navigate = currentSlide => {
        this.setState({ currentSlide });
    }

    getChildProps = () => ({
        navigate: this.navigate,
        appUnderReview: this.props.appUnderReview,
        isTransactionalFlow: this.props.isTransactionalFlow,
        workflowId: this.props.workflowId,
        dueDate: this.props.dueDate,
        workflowStatus: this.props.workflowStatus,
        requiredDocuments: this.props.requiredDocuments,
        finalSubmitRetryCount: this.props.finalSubmitRetryCount
    });

    render() {
        const { appPendSupported, currentSlide } = this.state;
        const props = this.getChildProps();
        const CurrentSlide = AppPendSlides[currentSlide];
        const renderCurrentSlide = appPendSupported ? <CurrentSlide {...props} /> : <OlderVersionAppPage {...props} />;
        return (
            <div className="outerWrapper us-wrapper">
                <div id="wrapper">
                    <div id="main" style={{ padding: '0' }} >
                        <div id={appPendSupported ? currentSlide : 'OlderVersionAppPage'}>
                            <Header singleColumnLayout={true} appPendHeaderStyle={true} />
                            {renderCurrentSlide}
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        );
    }
}

export const mapStateToProps = state => {
    const { workflowStatus = '', verificationDetails = [] } = get(state, 'serverData.appPendData.documentVerificationDetails.requiredDocumentsData.data.getVerificationDetails', '');

    let appUnderReview = false;

    if (workflowStatus === WORKFLOW_STATUS.PENDING_REVIEW) {
        appUnderReview = true;
    }

    return {
        workflowId: get(state, 'serverData.appPendData.workflowId', ''),
        dueDate: get(state, 'serverData.appPendData.documentVerificationDetails.dueDate', ''),
        workflowStatus,
        requiredDocuments: verificationDetails,
        flow: get(state, 'serverData.flow', ''),
        isTransactionalFlow: get(state, 'serverData.transactionalFlow', false),
        appUnderReview,
        finalSubmitRetryCount: get(state, 'serverData.appPendData.finalSubmitRetryCount', 0)
    };
};

export const mapDispatchToProps = dispatch => ({
    onComponentDidMount(workflowId) {
        dispatch(trackTransition('apply_pp_credit_appPendPage', 'prepare_pp_credit_appPendPage', { ...(workflowId && { workflow_id: workflowId }) }));
        return dispatch(getAppPendVerificationDetails());
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(AppPendPage);
